export default "__VITE_ASSET__1VSGuMq4__"